/**
 * 前端项目配置文件
 */
const projectName = '民族服饰展示平台' // 项目名称
const ip = '47.108.174.230'//47.108.174.230
const port= '9090'
const serverHost = 'http://'+ip+':'+port // 接口服务器地址

export { projectName, serverHost }
